import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  categorySlug?: string;
}

export default function Breadcrumb({ items, categorySlug }: BreadcrumbProps) {
  const resolvedItems = items.map(item => {
    if (item.href && categorySlug && item.href.includes(':slug')) {
      return {
        ...item,
        href: item.href.replace(':slug', categorySlug),
        label: item.label.includes('{category}') 
          ? item.label.replace('{category}', categoryMap[categorySlug] || categorySlug)
          : item.label,
      };
    }
    return item;
  });

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: resolvedItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://yinghua-video.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {resolvedItems.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-400 mx-1">/</span>
              )}
              {item.href && index < resolvedItems.length - 1 ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={index === resolvedItems.length - 1 ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}